import type { Budget } from "@shared/types";
import { ProjectDocRepository } from "./ProjectDocRepository";
import { defaultBudgetCategories } from "@domain/project/projectData";
import { buildPlanB } from "@domain/budget/planB";

/**
 * Per-project budget stored at users/{ownerUid}/projects/{pid}/data/budget-b.
 *
 * Default is the Plan B budget derived from projectData's defaultBudgetCategories.
 * Phase 1+ will migrate the hardcoded defaults out into per-persona templates
 * (homeowner starts with a blank template, contractor clones from a saved
 * org-level template).
 */
class BudgetRepository extends ProjectDocRepository<Budget> {
  readonly key = "budget-b";
  readonly defaultValue = buildPlanB(defaultBudgetCategories);
}

export const budgetRepository = new BudgetRepository();
